module.exports = __webpack_public_path__ + "static/media/bg.923df20f.png";